export const statusMap = [{
    status: 0,
    name: '等待付款',
}, {
    status: 1,
    name: '已关闭',
}, {
    status: 2,
    name: '待发货',
}, {
    status: 3,
    name: '已发货',
}, {
    status: 4,
    name: '交易成功',
}, {
    status: 5,
    name: '已退货',
}
];

export const menus = [
    {
    id: 1,
    name: '订单列表',
    router: 'OrderList',
    icon: 'dingdanliebiao-xuanzhong1',
},
    {
    id: 8,
    name: '安装公司',
    router: 'InstallationCompany',
    icon: 'mendianguanli-xuanzhong',
}, {
    id: 9,
    name: '安装列表',
    router: 'InstallationList',
    icon: 'dingdanliebiao-xuanzhong1',
},

//     {
//     id: 2,
//     name: '佣金明细',
//     router: 'Brokerage',
//     icon: 'yongjinmingxi-xuanzhong',
// }, {
//     id: 3,
//     name: '订单报表',
//     router: 'Report',
//     icon: 'dingdanbaobiao-xuanzhong',
// }, {
//     id: 4,
//     name: '员工管理',
//     router: 'Management',
//     icon: 'mendianguanli-xuanzhong',
// }, {
//     id: 5,
//     name: '供应链下单',
//     router: 'SupplyChain',
//     icon: 'pifashichang-xuanzhong',
// }, {
//     id: 6,
//     name: '收费标准',
//     router: 'Charge',
//     icon: 'shoufeibiaozhun-xuanzhong',
// }, {
//     id: 7,
//     name: '商品提成设置',
//     router: 'GoodsSetup',
//     icon: 'mendianguanli-xuanzhong',
// }
];
//员工
export const menus2 = [
    // {
//     id: 1,
//     name: '订单列表',
//     router: 'OrderList',
//     icon: 'dingdanliebiao-xuanzhong1',
// },

{
    id: 9,
    name: '安装单列表',
    router: 'InstallationList',
    icon: 'dingdanliebiao-xuanzhong1',
},
    {
        id: 10,
        name: '安装队列表',
        router: 'InstallTeamList',
        icon: 'dingdanliebiao-xuanzhong1',
    }, {
        id: 15,
        name: '派工列表',
        router: 'PaigongLists',
        icon: 'dingdanliebiao-xuanzhong1',
    },
    {
        id: 8,
        name: '完工列表',
        router: 'InstallationCompany',
        icon: 'mendianguanli-xuanzhong',
    },
    // {
    //     id: 11,
    //     name: '物流公司列表',
    //     router: 'LogisticsCompany',
    //     icon: 'dingdanliebiao-xuanzhong1',
    // },
    // {
    //     id: 12,
    //     name: '送货司机列表',
    //     router: 'DriverList',
    //     icon: 'dingdanliebiao-xuanzhong1',
    // },

//     {
//     id: 5,
//     name: '供应链下单',
//     router: 'SupplyChain',
//     icon: 'pifashichang-xuanzhong',
// }
// , {
//     id: 7,
//     name: '返回商城',
//     router: 'http://shop.gzestars.com/',
//     icon: 'shoufeibiaozhun-xuanzhong',
// }
];



// WEBPACK FOOTER //
// ./src/utils/config.js